// extracted by mini-css-extract-plugin
export var imgContent = "index-module--imgContent--5yGPR";
export var inner = "index-module--inner--rWwIF";
export var wrapper = "index-module--wrapper--adVFC";